export const landingPageEdges = [
  {
    id: "135.127.3.223-210.59.227.148",
    source: "135.127.3.223",
    target: "210.59.227.148",
    type: "straight",
  },
  {
    id: "158.115.118.151-210.59.227.148",
    source: "158.115.118.151",
    target: "210.59.227.148",
    type: "straight",
  },
  {
    id: "158.115.118.151-165.172.71.197",
    source: "158.115.118.151",
    target: "165.172.71.197",
    type: "straight",
  },
  {
    id: "165.172.71.197-243.84.74.124",
    source: "165.172.71.197",
    target: "243.84.74.124",
    type: "straight",
  },
  {
    id: "158.115.118.151-243.84.74.124",
    source: "158.115.118.151",
    target: "243.84.74.124",
    type: "straight",
  },
  {
    id: "103.27.183.59-158.115.118.151",
    source: "103.27.183.59",
    target: "158.115.118.151",
    type: "straight",
  },
  {
    id: "31.32.181.182-103.27.183.59",
    source: "31.32.181.182",
    target: "103.27.183.59",
    type: "straight",
  },
  {
    id: "31.32.181.182-219.126.205.224",
    source: "31.32.181.182",
    target: "219.126.205.224",
    type: "straight",
  },
  {
    id: "31.32.181.182-158.115.118.151",
    source: "31.32.181.182",
    target: "158.115.118.151",
    type: "straight",
  },
  {
    id: "135.127.3.223-219.126.205.224",
    source: "135.127.3.223",
    target: "219.126.205.224",
    type: "straight",
  },
  {
    id: "103.27.183.59-243.84.74.124",
    source: "103.27.183.59",
    target: "243.84.74.124",
    type: "straight",
  },
  {
    id: "29.52.143.155-158.115.118.151",
    source: "29.52.143.155",
    target: "158.115.118.151",
    type: "straight",
  },
  {
    id: "165.172.71.197-234.162.245.59",
    source: "165.172.71.197",
    target: "234.162.245.59",
    type: "straight",
  },
  {
    id: "135.127.3.223-251.40.88.159",
    source: "251.40.88.159",
    target: "135.127.3.223",
    type: "straight",
  },
];
